export default "__VITE_ASSET__BtM1oCpc__"